module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/error-img.815f3248.svg";